import { FileText } from "lucide-react";

import { Button } from "@/components/ui/button";

interface InvoiceFile {
  url: string;
  filename: string;
}

interface AttachmentsSectionProps {
  processedPdf: InvoiceFile | null;
  invoiceFiles: InvoiceFile[];
}

function AttachmentLink({ file }: { file: InvoiceFile }) {
  return (
    <Button
      variant="ghost"
      size="sm"
      asChild
      className="h-auto justify-start px-3 py-2"
    >
      <a href={file.url} target="_blank" rel="noopener noreferrer">
        <FileText className="h-4 w-4 mr-2" />
        <span className="text-sm">{file.filename}</span>
      </a>
    </Button>
  );
}

export default function AttachmentsSection({
  processedPdf,
  invoiceFiles,
}: AttachmentsSectionProps) {
  if (!processedPdf && invoiceFiles.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-base font-medium">Archivos Adjuntos</h2>
      <div className="space-y-4">
        {processedPdf && (
          <div className="space-y-2">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              PDF Procesado
            </p>
            <AttachmentLink file={processedPdf} />
          </div>
        )}

        {invoiceFiles.length > 0 && (
          <div className="space-y-2">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Facturas Originales
            </p>
            <div className="flex flex-col gap-1">
              {invoiceFiles.map((file, index) => (
                <AttachmentLink key={index} file={file} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
